import Action from 'redux/helpers/createAction'
const name = 'filters'

export const setFilters = Action(name + '/SET_FILTERS', filters => ({
  filters
}))

export const resetFilters = Action(name + '/RESET_FILTERS')
